// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-primary[data-v-241cb17a] {\n  color: #003399 !important;\n}\n", ""]);
// Exports
module.exports = exports;
